import React from "react";
import { ArrowRight, ShieldCheck, Award } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VeteranOwnedDetailOriented() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="43181" id="foundation" ref={ref} className="dark bg-background text-foreground relative w-full py-24 lg:py-32 overflow-hidden">
      {}
      <div className="pointer-events-none absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-primary/10 blur-[120px] opacity-40 mix-blend-screen" />
        <div className="absolute bottom-[10%] right-[5%] w-[40%] h-[40%] rounded-full bg-primary/5 blur-[100px] opacity-30 mix-blend-screen" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6 z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div className={`flex flex-col gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="flex items-center gap-3">
              <Badge variant="outline" className="font-mono text-primary border-primary/30 bg-primary/10 px-3 py-1 text-xs tracking-widest uppercase">
                PREMIUM SEALANT
              </Badge>
              <Separator className="w-12 bg-primary/30" />
            </div>

            <h2 className="text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter leading-[0.9] text-foreground">
              ULTIMATE <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-foreground to-foreground/60">
                SEAL
              </span>
            </h2>

            <div className="flex items-center gap-4 mt-4">
              <div className="h-1 w-24 bg-primary rounded-full shadow-[0_0_15px_var(--ring)]" />
              <p className="font-mono text-sm text-muted-foreground tracking-wider uppercase">
                Island Seals Pro
              </p>
            </div>
          </div>

          {}
          <div className={`flex flex-col gap-8 pt-4 lg:pt-12 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-6">
              <h3 className="text-2xl md:text-3xl font-semibold text-foreground tracking-tight">
                Precision. Sealing. <span className="text-primary">Protection.</span>
              </h3>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
                We provide advanced structural waterproofing and concrete sealing designed for longevity. 
                In masonry preservation, there is no margin for error against the elements. 
                Our specialized techniques ensure deep penetration, absolute moisture resistance, 
                and a protective barrier that safeguards your investment against erosion and decay.
              </p>
            </div>

            {}
            <Card className="relative overflow-hidden border border-border/50 bg-card/30 backdrop-blur-md shadow-2xl shadow-black/20 mt-4 group">
              {}
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary shadow-[0_0_10px_var(--primary)]" />
              
              <CardContent className="p-8 flex flex-col sm:flex-row gap-6 items-start sm:items-center justify-between">
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-primary mb-1">
                    <ShieldCheck className="w-5 h-5" />
                    <span className="font-bold text-sm tracking-wide uppercase">Technical Specs</span>
                  </div>
                  <p className="text-foreground/90 font-medium text-lg">Eco friendly moisture resistance for every surface.</p>
                </div>
                
                <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 border-0 transition-all duration-300 hover:scale-105 whitespace-nowrap">
                  <Link to="/RequestQuotePage">
                    Request Quote <ArrowRight className="ml-2 w-4 h-4" />
                  </Link>
                </Button>
              </CardContent>

              {}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out pointer-events-none" />
            </Card>

            <div className="grid grid-cols-2 gap-6 mt-2">
              {[{
              label: "Moisture Barrier",
              icon: ShieldCheck
            }, {
              label: "UV Resistant",
              icon: Award
            }].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-3 text-muted-foreground">
                  <item.icon className="w-5 h-5 text-primary/70" />
                  <span className="text-sm font-medium uppercase tracking-wide">{item.label}</span>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}